import { AxiosRequestConfig } from 'axios'

const getReward = (id: string): AxiosRequestConfig => ({
  url: `/tasks/reward`,
  method: 'POST',
  params: {
    id
  }
})

export { getReward }
